import { render, staticRenderFns } from "./EditSpecialResuply.vue?vue&type=template&id=71a06960&scoped=true"
import script from "./EditSpecialResuply.vue?vue&type=script&lang=js"
export * from "./EditSpecialResuply.vue?vue&type=script&lang=js"
import style0 from "./EditSpecialResuply.vue?vue&type=style&index=0&id=71a06960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a06960",
  null
  
)

export default component.exports